export default "__VITE_ASSET__DRFItmwj__"